import { chooseIndefiniteArticle } from 'util/strings'

const getLinkText = provider => {
  if (provider === 'github') return 'GitHub issue'
  return 'Unknown integration'
}

const IntegrationAction = action => {
  const { change: { provider, removed, title, url } = {} } = action
  if (provider === 'hubspot') {
    return (
      <React.Fragment>
        created {title} as a{' '}
        <a target="_blank" rel="noopener noreferrer" href={url}>
          contact
        </a>
      </React.Fragment>
    )
  }

  if (provider === 'salesforce') {
    return (
      <React.Fragment>
        created {title} as a{' '}
        <a target="_blank" rel="noopener noreferrer" href={url}>
          lead
        </a>
      </React.Fragment>
    )
  }

  if (['github', 'jira_cloud', 'jira_server', 'trello'].includes(provider)) {
    return (
      <React.Fragment>
        {removed
          ? 'unlinked this conversation from '
          : 'linked this conversation to '}
        <a target="_blank" rel="noopener noreferrer" href={url}>
          {title}
        </a>
      </React.Fragment>
    )
  }

  const linkText = getLinkText(provider)
  const direction = removed ? 'removed this from' : 'added this to'
  const base = `${direction} ${chooseIndefiniteArticle(linkText)} `

  return (
    <React.Fragment>
      {base}
      <a target="_blank" rel="noopener noreferrer" href={url}>
        {linkText}
      </a>
    </React.Fragment>
  )
}

export default IntegrationAction
